import { ISort } from '../interfaces/Sort';

export const getSortQueryParam = (sort: ISort, defaultFieldName: string) => {
    if (!sort.dir && !sort.key) {
        // Just a regular view, order by default field name ascending
        return defaultFieldName;
    } else if (sort.dir && sort.key) {
        const keyArr = sort.key.split(',');
        return keyArr.map((key) => {
            return sort.dir === 'asc' ? key : `-${key}`;
        }).join(',');
    } else {
        return sort.dir === 'asc' ? sort.key : `-${sort.key}`;
    }
};

export const getSortQueryParamAssessment = (sort: ISort, defaultFieldName: string) => {
    if (!sort.dir && !sort.key) {
        if (defaultFieldName === 'feedbackDate') {
            return `${defaultFieldName}`;
        }
        // Just a regular view, order by default field name ascending
        return `-${defaultFieldName}`;
    } else if (sort.dir && sort.key) {
        const keyArr = sort.key.split(',');
        return keyArr.map((key) => {
            return sort.dir === 'asc' || key === 'feedbackDate' ? key : `-${key}`;
        }).join(',');
    } else {
        return sort.dir === 'asc' || sort.key === 'feedbackDate' ? sort.key : `-${sort.key}`;
    }
};
